import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SwitchBase from '../switchBase';
import RadioButtonChecked from '../icons/internals/RadioButtonChecked';
import RadioButtonUnchecked from '../icons/internals/RadioButtonUnchecked';

const propTypes = {
  prefixCls: PropTypes.string,
  /** 标签文本 */
  label: PropTypes.node,
  /** 是否禁用 */
  disabled: PropTypes.bool,
  /** 选中状态（适用于受控组件） */
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** 选中状态默认值 */
  defaultChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** 选中状态icon */
  checkedIcon: PropTypes.node,
  className: PropTypes.string,
  /** 未选中状态icon */
  uncheckedIcon: PropTypes.node,
  /** 获取input的ref */
  inputRef: PropTypes.func,
  /** 选中状态改变时的回调 function(e, checked) */
  onChange: PropTypes.func,
};
const defaultProps = {
  defaultChecked: false,
  prefixCls: 'ne-radio',
  disabled: false,
  checkedIcon: <RadioButtonChecked />,
  uncheckedIcon: <RadioButtonUnchecked />,
};
/**
 * Radio
 */
export default function Radio(props) {
  const { prefixCls, className, ...other } = props;
  return <SwitchBase className={classNames(prefixCls, className)} {...other} type="radio" />;
}

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;



// WEBPACK FOOTER //
// ./src/radio/Radio.jsx